import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { ApService } from 'src/app/shared/services/ap.service';
import { Timezone } from 'src/app/shared/model/timezone'
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import Chart from 'chart.js';
import { NovuTransactionsModalComponent } from '../../../novu-transactions-modal/novu-transactions-modal.component';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

import { resolveDeviceTimezone, deviceTimezoneLabel } from 'src/app/shared/helper/device-timezone';

@Component({
  selector: 'app-device-alert-link-state',
  templateUrl: './device-alert-link-state.component.html',
  styleUrls: ['./device-alert-link-state.component.scss']
})
export class DeviceAlertLinkStateComponent implements OnInit {
  
  @Input() selfSort: any;
  @Input() set deviceInfo(obj) {
    if (obj) {
      this._device = obj;
    }
  }
  @Output() refresh = new EventEmitter<void>();
  @Output() sortChange = new EventEmitter<any>();
  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  private listOfDeviceState: Subscription;
  selectedTabIndex: number = 0;
  chartLink1: any;
  chartLink2: any;
  chartLink3: any;
  chartLinkB1: any;
  _device: any = []
  displayedColumns: string[] = ["Date Processed", "TransactionId", "Status", 'Action'];
  dynamicColumns: string [] = []
  col: any;
  dir: any;
  data = []
  _dataSource: MatTableDataSource<any>;  
  deviceId = ""
  trackStatus = []
  searchMonthPipe = ""
  searchDatePipe = ""
  searchPipe = ""
  listOfMonths = []
  listOfDates = []
  selectedMonth = ""
  selectedDate = ""
  selectedTimezone = "America/New_York"
  deviceForm: any;
  graphCount: any = []
  upLink1Cnt = 0
  downLink1Cnt = 0
  upLink2Cnt = 0
  downLink2Cnt = 0
  upLink3Cnt = 0
  downLink3Cnt = 0
  upLinkB1Cnt = 0
  downLinkB1Cnt = 0
  monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
  ];
  timezoneArray = Timezone;
  loading = true;

  currentPage = 1;
  page = 0
  pageSize = 10
  length = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  pageEvent: PageEvent;

  constructor( private changeDetection: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    public apService: ApService,
    public dialog: MatDialog,
    private ref: ChangeDetectorRef,
    public route: ActivatedRoute,
    private router: Router,) { 
    this.deviceForm = this.formBuilder.group({
      searchMonth: new FormControl(null),
      searchDate: new FormControl(null),
      searchTimezone: new FormControl(null),
    });
    this._dataSource = new MatTableDataSource<any>();
  }

  ngOnInit(): void {
    this.deviceId = this.route.snapshot.paramMap.get('device_id');
    this.getMonths()
    this.getDates()
    this.initMonthDate()
    // this.loadCustomizedDate() 
    this.selectedTimezone = resolveDeviceTimezone(this._device?.[0]?.statistics?.timezone);
    this.deviceForm.controls.searchTimezone.setValue(this.selectedTimezone);
    this.loadFilteredDates()  
  }
  ngAfterViewInit() {
    if (this.selfSort) {
      this.paginator.length = this.length;
      this._dataSource.paginator = this.paginator;
      this._dataSource.sort = this.sort;
      this.changeDetection.markForCheck();
    } else {
      this.sort.sortChange.subscribe(() => {
        this.sortChange.emit(this.sort)
      });
    }
    this.changeDetection.detectChanges();
  }
  initDynamicColumns(){
    this.dynamicColumns = []
    if(this.data && this.data.length > 0) {
      const links = this.data[0]["links"] ?? []
      if(links && links.length > 0){      
        links.forEach(l => {
          this.dynamicColumns.push(l.link)
          // this.dynamicColumns.push(l.link + " State Changed")
          // this.dynamicColumns.push(l.link + " Link Alert")
        });
        this.displayedColumns.forEach(d=>{
          this.dynamicColumns.push(d)
        })
      }else {      
        this.dynamicColumns = this.displayedColumns
      }
    }else {
      this.dynamicColumns = this.displayedColumns
    }
    
  }
  initMonthDate(){
    var today = new Date();
    this.selectedMonth = this.monthNames[today.getMonth()] + ' - ' +today.getFullYear()
    this.selectedDate = today.getDate().toString()
    this.deviceForm.controls.searchMonth.setValue(this.selectedMonth);
    this.deviceForm.controls.searchDate.setValue(this.selectedDate);
  }
  displayLinkState(state){
    if(state){
      return "Up"    
    } else {
      return "Down"
    }
  }
  displayStatus(status){
    if( status == true) {
      return "Sent"
    } else {
      return "Failed"
    }
  }
  displayYesNo(status){
    if( status == true) {
      return "Yes"
    } else {
      return "No"
    }
  }
  displayTimezone(tz){
    return deviceTimezoneLabel(tz);
  }
  displayFormatTimeZone(date,tz){
    const tzone = resolveDeviceTimezone(this.selectedTimezone || tz);
    return moment(date).tz(tzone).format('ddd MMM D YYYY HH:mm:ss zz')
  }
  private destroyChartInstance(chart: any) {
    if (chart) {
      chart.destroy();
    }
  }
  private createDoughnutChart(canvasId: string, data: number[]) {
    const canvas = document.getElementById(canvasId) as HTMLCanvasElement | null;
    const context = canvas?.getContext('2d');
    if (!canvas || !context) {
      return null;
    }
    return new Chart(context, {
      type: 'doughnut',
      data: {
        labels: ['Up', 'Down'],
        datasets: [
          {
            data,
            backgroundColor: ['#34a854', '#e81123'],
            fill: false
          },
        ]
      },
      options: {
        legend: {
          display: false
        },
        tooltips: {
          enabled: true
        }
      }
    });
  }
  displayResult() {
    if (this.selfSort) {
      this._dataSource.data = this.data;
      this.length = this.data.length;
    } else {
      this._dataSource.data = this.data;
    }
  }
  drawLink1Chart() {
    this.destroyChartInstance(this.chartLink1);
    this.upLink1Cnt = this.graphCount.link1.downtime == 0 && this.graphCount.link1.uptime == 0 ? 0 : 100.00 - parseFloat(this.graphCount.link1.downtime)
    this.downLink1Cnt =  parseFloat(this.graphCount.link1.downtime)
    this.chartLink1 = this.createDoughnutChart('link1-canvas', [this.upLink1Cnt, this.downLink1Cnt]);

  }
  drawLink2Chart() {
    this.destroyChartInstance(this.chartLink2);
    this.upLink2Cnt = this.graphCount.link2.downtime == 0 && this.graphCount.link2.uptime == 0 ? 0 : 100.00 - parseFloat(this.graphCount.link2.downtime)
    this.downLink2Cnt =  parseFloat(this.graphCount.link2.downtime)
    this.chartLink2 = this.createDoughnutChart('link2-canvas', [this.upLink2Cnt, this.downLink2Cnt]);

  }
  drawLink3Chart() {
    this.destroyChartInstance(this.chartLink3);
    this.upLink3Cnt = this.graphCount.link3.downtime == 0 && this.graphCount.link3.uptime == 0 ? 0 : 100.00 - parseFloat(this.graphCount.link3.downtime)
    this.downLink3Cnt =  parseFloat(this.graphCount.link3.downtime)
    this.chartLink3 = this.createDoughnutChart('link3-canvas', [this.upLink3Cnt, this.downLink3Cnt]);

  }
  drawLinkB1Chart() {
    this.destroyChartInstance(this.chartLinkB1);
    this.upLinkB1Cnt = this.graphCount.linkB1.downtime == 0 && this.graphCount.linkB1.uptime == 0 ? 0 : 100.00 - parseFloat(this.graphCount.linkB1.downtime)
    this.downLinkB1Cnt =  parseFloat(this.graphCount.linkB1.downtime)
    this.chartLinkB1 = this.createDoughnutChart('linkB1-canvas', [this.upLinkB1Cnt, this.downLinkB1Cnt]);

  }
  getMonths(){
    var today = new Date();

    for (let i = 0; i < 3; i++) {
      this.listOfMonths.push(this.monthNames[(today.getMonth() - i)] + ' - ' +today.getFullYear()  );
    }
  }
  getDates(){
    this.listOfDates = []
    var selection = ""
    var curMonth = new Date().getMonth();
    var numDays = 0
    if(this.selectedMonth == ""){
      selection = new Date().getFullYear() + "-" + new Date().getMonth()
      numDays = new Date().getDate();
      
    } else {
      const m = this.selectedMonth.split(" - ")
      selection = m[1] +"-"+ (this.monthNames.indexOf(m[0]) +1)
      if(this.monthNames.indexOf(m[0]) === curMonth) {
        numDays = new Date().getDate();
      } else {
        numDays = moment(selection, "YYYY-MM").daysInMonth()
      }
    }
    for (let i = numDays; i >= 1; i--) {
      this.listOfDates.push(i.toString());
    }
    this.deviceForm.controls.searchDate.setValue(numDays.toString());
  }
  handlePageEvent(event: PageEvent) {
    this.currentPage = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.loadFilteredDates()
  }
  loadCustomizedDate(){
    const my = this.selectedMonth.split(' - ')
    const month = this.monthNames.indexOf(my[0]) + 1
    const year = my[1]
    const day = this.selectedDate
    const dateFrom = moment(year+"-"+month+"-"+day+" 00:00:00Z").toISOString()
    const dateTo = moment(year+"-"+month+"-"+day+" 23:59:59Z").toISOString()
    this.loadLinksStates(dateFrom, dateTo)
  }
  loadLinksStates(dateFrom, dateTo){    
    const request =   {
      deviceId: this.deviceId,     
      date_from: dateFrom,
      date_to: dateTo,
      page: this.currentPage,
      pageSize: this.pageSize
    }
    this.apService.getLinkState(request).subscribe(res=>{
      this.loading = false
      this.data = res.data
      this._dataSource.data = res.data
      this.length = res.count.all
      this.initDynamicColumns()
    })
  }
  loadLinksCalc(dateFrom, dateTo, type){
    const request =   {
      deviceId: this.deviceId,     
      date_from: dateFrom,
      date_to: dateTo,
      type: type
    }
    this.apService.getLinkCalc(request).subscribe(res=>{
      this.loading = false
      this.data = res.data
      this.graphCount = res.data
      this.drawLink1Chart()
      this.drawLink2Chart()
      this.drawLink3Chart()
      this.drawLinkB1Chart()
    })
  }
  loadFilteredDates(){
    let ed, sd, date_from, date_to
    switch (this.selectedTabIndex) {
      case 0: // 4 hrs
        ed = moment(new Date()).tz(this.selectedTimezone);
        sd = moment(new Date(new Date(ed).getTime() - (4 * 60 * 60 * 1000))).tz(this.selectedTimezone);
        date_from = moment(sd).toISOString()
        date_to = moment(ed).toISOString()
        this.loadLinksStates(date_from, date_to)
        this.loadLinksCalc(date_from, date_to, 0)
        break;
    
      case 1: // 24 hrs
        ed = moment(new Date()).tz(this.selectedTimezone);
        sd = moment(new Date(new Date(ed).getTime() - (24 * 60 * 60 * 1000))).tz(this.selectedTimezone);
        date_from = moment(sd).toISOString()
        date_to = moment(ed).toISOString()
        this.loadLinksStates(date_from, date_to)
        this.loadLinksCalc(date_from, date_to, 1)
        break;

      case 2: // 7 days
        ed = moment(new Date()).tz(this.selectedTimezone);
        sd = moment(new Date(new Date(ed).getTime() - (7 * 24 * 60 * 60 * 1000))).tz(this.selectedTimezone);
        date_from = moment(sd).toISOString()
        date_to = moment(ed).toISOString()
        this.loadLinksStates(date_from, date_to)
        this.loadLinksCalc(date_from, date_to, 2)
        break;
    
      case 3: // this month
        ed = moment(new Date()).tz(this.selectedTimezone);
        sd = moment(ed).startOf('month').tz(this.selectedTimezone);
        date_from = moment(sd).toISOString()
        date_to = moment(ed).toISOString()
        this.loadLinksStates(date_from, date_to)
        this.loadLinksCalc(date_from, date_to, 3)
        break;

      case 4: // last month
        ed =moment(new Date()).subtract(1, 'months').endOf('month').tz(this.selectedTimezone);
        sd = moment(ed).startOf('month').tz(this.selectedTimezone);
        date_from = moment(sd).toISOString()
        date_to = moment(ed).toISOString()
        this.loadLinksStates(date_from, date_to)
        this.loadLinksCalc(date_from, date_to, 4)
        break;

      default:
        break;
    }   
  }
  onSelectionMonthChange(event){
    if(event.value){
      this.selectedMonth = event.value;
      this.getDates()
      // this.loadHistoryData(this.type);
    }
  }
  onSelectionTZChange(event){
    if(event.value){
      this.selectedTimezone = event.value;
      this.loadFilteredDates()
    }
  }
  onSelectionDateChange(event){
    let dateFrom, dateTo
    if(event.value){
      this.selectedDate = event.value;
      
    }
    this.loadLinksStates(dateFrom,dateTo);
  }
  searchMonthFocus(){
    // setTimeout(() => {
    //   this.searchElement.nativeElement.focus();
    // }, 50);
  } 
  searchDateFocus(){
    // setTimeout(() => {
    //   this.searchElement.nativeElement.focus();
    // }, 50);
  }
  searchFocus(){

  }
  sortData(sort: Sort) {
    if (this.selfSort) {
      const data = this.trackStatus.slice();
      if (!sort.active || sort.direction === '') {
        this._dataSource.data = data;
        return;
      }

      function compare(a: number | string, b: number | string, isAsc: boolean) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
      }

      this._dataSource.data = data.sort((a, b) => {
        const isAsc = sort.direction === 'asc';
        switch (sort.active) {
          case 'name': return compare(a.name, b.name, isAsc);
          case 'mac': return compare(a.mac, b.mac, isAsc);
          case 'msp': return compare(a.msp, b.msp, isAsc);
          case 'domain': return compare(a.domain, b.domain, isAsc);
          case 'location': return compare(a.location, b.location, isAsc);
          case 'model': return compare(a.deviceMetaInfo.deviceModel, b.deviceMetaInfo.deviceModel, isAsc);
          case 'firmware': return compare(a.statistics.firmware ? a.statistics.firmware?.currentVersion : '', b.statistics.firmware ? b.statistics.firmware.currentVersion : '', isAsc);
          case 'baseLicense': return compare(a.baseLicense, b.baseLicense, isAsc);
          case 'orderdate': return compare(a.orderdate, b.orderdate, isAsc);
          case 'activatedAt': return compare(a.activatedAt, b.activatedAt, isAsc);
          case 'createdAt': return compare(a.createdAt, b.createdAt, isAsc);
          case 'lastSeen': return compare(a.lastSeen, b.lastSeen, isAsc);
          // case 'status': return compare(this.getStatus(a.lastSeen, a.track), this.getStatus(b.lastSeen,b.track), isAsc);
          default: return 0;
        }
      });
    }
  }
  selectedTabChange(event){
    if(event) {
      this.selectedTabIndex = event.index
      this.loadFilteredDates()
    }    
  }
  viewNovu(data): void {
    const dialogRef = this.dialog.open(NovuTransactionsModalComponent, {
      disableClose: true,
      width: '1000px',
      data: { data, showDevice: false},   
    });

    dialogRef.afterClosed().subscribe(result => {
      // this.loadData();
    });
  }
}
